const CONST = {
    // Registration
    'REGISTER_USER_SUCCESS': 'AUTH/REGISTER_USER_SUCCESS',
    'REGISTER_USER_FAILED': 'AUTH/REGISTER_USER_FAILED',
    'START_PROCESS_SUCCESS': 'AUTH/START_PROCESS_SUCCESS',
    'START_PROCESS_FAILED': 'AUTH/START_PROCESS_FAILED',

    // Login/Logout
    'LOGIN_SUCCESS': 'AUTH/LOGIN_SUCCESS',
    'LOGIN_FAILED': 'AUTH/LOGIN_FAILED',
    'LOGIN_LOADING': 'AUTH/LOGIN_LOADING',
    'LOGOUT_SUCCESS': 'AUTH/LOGOUT_SUCCESS',
    'LOGOUT_FAILED': 'AUTH/LOGOUT_FAILED',
    'LOGOUT_LOADING': 'AUTH/LOGOUT_LOADING',

    // Token Management
    'REFRESH_TOKEN_SUCCESS': 'AUTH/REFRESH_TOKEN_SUCCESS',
    'REFRESH_TOKEN_FAILED': 'AUTH/REFRESH_TOKEN_FAILED',
    'REFRESH_TOKEN_LOADING': 'AUTH/REFRESH_TOKEN_LOADING',

    // Email Verification
    'VERIFY_EMAIL_SUCCESS': 'AUTH/VERIFY_EMAIL_SUCCESS',
    'VERIFY_EMAIL_FAILED': 'AUTH/VERIFY_EMAIL_FAILED',

    // OTP Verification
    'VERIFY_OTP_SUCCESS': 'AUTH/VERIFY_OTP_SUCCESS',
    'VERIFY_OTP_FAILED': 'AUTH/VERIFY_OTP_FAILED',
    'RESEND_OTP_SUCCESS': 'AUTH/RESEND_OTP_SUCCESS',
    'RESEND_OTP_FAILED': 'AUTH/RESEND_OTP_FAILED',

    // Password Management
    'FORGOT_PASSWORD_SUCCESS': 'AUTH/FORGOT_PASSWORD_SUCCESS',
    'FORGOT_PASSWORD_FAILED': 'AUTH/FORGOT_PASSWORD_FAILED',
    'SET_PASSWORD_SUCCESS': 'AUTH/SET_PASSWORD_SUCCESS',
    'SET_PASSWORD_FAILED': 'AUTH/SET_PASSWORD_FAILED',

    // User Management
    'UPDATE_PROFILE_SUCCESS': 'AUTH/UPDATE_PROFILE_SUCCESS',
    'UPDATE_PROFILE_FAILED': 'AUTH/UPDATE_PROFILE_FAILED',
    'REFRESH_USER_SUCCESS': 'AUTH/REFRESH_USER_SUCCESS',
    'REFRESH_USER_FAILED': 'AUTH/REFRESH_USER_FAILED',

    // Notifications
    'MARK_NOTIFICATION_READ_SUCCESS': 'NOTIFICATION/MARK_NOTIFICATION_READ_SUCCESS',
    'MARK_NOTIFICATION_READ_FAILED': 'NOTIFICATION/MARK_NOTIFICATION_READ_FAILED',

    // Favorites
    'TOGGLE_FAVORITE': 'AUTH/TOGGLE_FAVORITE',
}

export default CONST;